import { render, staticRenderFns } from "./RegistrationCancelMenu.vue?vue&type=template&id=6a349a70"
import script from "./RegistrationCancelMenu.vue?vue&type=script&lang=js"
export * from "./RegistrationCancelMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports